export const MODERATION_RULES_LINK =
    'https://yandex.ru/support2/rythm/ru/buisness/moderation#tematiki,-kotorye-ne-razmeshayutsya-v-yandeks-ritme';
